import auth0 from 'auth0-js';
import { AUTH_CONFIG } from './config';
import createLogger from '../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `Auth0.js`);

const connectionMap = {
  'google': 'google-oauth2',
  'facebook': 'facebook',
};

class Auth0 {
  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    audience: `https://${AUTH_CONFIG.domain}/userinfo`,
    responseType: 'token id_token', scope: 'openid email profile'
  });

  /* ---- email/password login ---- */
  login = (creds, callback) => {
    debug.enter(`login`);
    debug.log(`  creds:`, creds);

      //  this.auth0.client.login
    this.auth0.login(
      { realm: 'Username-Password-Authentication', ...creds },
      (err, res) => {
        debug.log(`  > login callback`);

        if (!err) {
          debug.log(`    success:`, res);
          this.setSession(res);
        }
        debug.log(`    error:`, err);
        callback(err, res);
      }
    );
  };


  /* ---- email/password registration ---- */
  register = (creds, callback) => {
    debug.enter(`register`);
    debug.log(`  creds:`, creds);

    this.auth0.redirect.signupAndLogin(
      { connection: 'Username-Password-Authentication', ...creds },
      (err, res) => {
        debug.log(`  > register callback`);

        if (!err) {
          debug.log(`    success:`, res);
          this.setSession(res);
        }
        debug.log(`    error:`, err);
        callback(err, res);
      }
    );
  };

  /* ---- social authentication ---- */
  authService = (service) => {
    debug.enter(`authenticateSocial`);
    debug.log(`  service: ${service}`);

    const connection = connectionMap[service];
    this.auth0.authorize({connection});
  };

  /* ---- social auth callback handler ---- */
  serviceCallback = (hash, callback) => {
    debug.enter(`socialCallback`);

    this.auth0.parseHash((err, res) => {
      debug.log(`  > socialCallback callback`);

      if (!err) {
        debug.log(`    success:`, res);
        this.setSession(res);
      }
      debug.log(`    error:`, err);
      callback(err, res);
    });
  };

  /* ---- retrieve auth0 user details ---- */
  getUserDetails = (callback) => {
    debug.enter(`getUserDetails`);

    if (!this.isAuthenticated()) {
      debug.log(`  error: not authenticated`);
      return callback({
        type: `noauth`,
        description: `user is not authenticated`,
      });
    }

    const accessToken = this.getSession().accessToken;
    this.auth0.client.userInfo(accessToken, (err, info) => {
      debug.log(`  > getUserDetails callback`);
      debug.log(`    err:`, err);
      debug.log(`    info:`, info);

      callback(err, info);
    });
  };

  /* ---- authentication check & update ---- */
  isAuthenticated = () => {
    debug.enter(`isAuthenticated`);

    const session = this.getSession();
    const expiresAt = !!session && session.expiresAt;
    const now = new Date().getTime();
    const idTokenPayload = !!session && session.idTokenPayload;

    debug.log(`  exp: ${expiresAt}`);
    debug.log(`  now: ${expiresAt}`);

    if (!expiresAt || !idTokenPayload) {
      debug.log(`  token missing; returning false`);
      return false;
    }

    if (now >= expiresAt) {
      debug.log(`  token expired; clearing session and returning false`);
      this.clearSession();
      return false;
    }

    debug.log(`  token valid; user is authenticated`);
    return true;
  };


  getUser = () => {
    const user = ls.getUser();
    const session = ls.getSession();

    /*
     *  changes to get expirations working breaking AD -- for some reason we don't get back idTokenPayload in AD.
     *  Took out tests
     */
    const now = new Date().getTime();
    debug.enter('getUser');
    if (session &&
      session.idToken &&
      session.accessToken &&
      session.idTokenPayload &&
      session.idTokenPayload.exp * 1000 >= now &&
      session.expiresAt) {
      return user;
    }
    return null;
  };
  setUser = (user) => {
    ls.setUser(user);
  };

  clearUser = () => ls.clearUser();


  /* -------- session management -------- */
  // JWT Token expiration from Auth0 is the 'exp' integer in the idTokenPayload and is in seconds.
  // The 'expiresIn' and 'expiresAt' integers in the session object are unrelated.
  getSession = () => {
    const session = ls.getSession();
    if (session &&
        session.idToken &&
        session.accessToken &&
        session.idTokenPayload &&
        session.expiresAt) {
      return session;
    }
    return null;
  };

  setSession = (token) => {
    if (token &&
        token.idToken &&
        token.accessToken) {
      ls.setSession({
        idToken: token.idToken,
        idTokenPayload: token.idTokenPayload,
        accessToken: token.accessToken,
        expiresAt: (token.expiresIn * 1000) + new Date().getTime(),
      })
    }
  };
  clearSession = () => ls.clearSession();
}

/* Local Storage helper */
const ls = {
  getSession: () => JSON.parse(localStorage.getItem('authSession') || 'null'),
  setSession: (session) => localStorage.setItem('authSession', JSON.stringify(session)),
  getUser: () => JSON.parse(localStorage.getItem('authUser') || 'null'),
  setUser: (user) => localStorage.setItem('authUser', JSON.stringify(user)),
  clearUser: () => localStorage.removeItem('authUser'),
  clearSession: () => localStorage.removeItem('authSession'),
};


export default new Auth0();




// WEBPACK FOOTER //
// ./src/auth/Auth0.js